import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, FormCheck } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SubmitButton from "components/SubmitButton";
import * as userActions from 'actions/userActions';
import { errorFormating, isLogin } from "utils/utils";
import Logo from "components/Logo";
import { resolvePostLoginRedirect } from "components/Onboarding";

class Register extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			accepted: false,
			user: {
				name: "",
				surname: "",
				company: "",
				code: "",
				email: "",
				password: "",
				confirmPassword: "",
			}
		};
	}

	componentDidMount() {
		isLogin();
	}

	validateForm() {
		const { user, accepted } = this.state;
		return (
			user.password.length > 5 &&
			user.password === user.confirmPassword &&
			accepted
		);
	}

	handleChange = event => {
		const { user } = this.state;

		this.setState({
			user: {
				...user,
				[event.target.id]: event.target.value
			}
		});
	}

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	handleSubmit = async event => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { user } = this.state;

		// Obtener el dominio actual
		const hostname = window.location.hostname;

		// Agregar el dominio al objeto user
		const userWithDomain = {
			...user,
			domain: hostname
		};

		await this.props.register(userWithDomain);

		if (this.props.loggedIn) {

			if ("ga" in window) {
				var tracker = window.ga.getAll()[0];
				if (tracker)
					tracker.send("event", "signup", "submit");
			}

			if (typeof gtag === "function") {
				gtag('event', 'conversion', {
					'send_to': 'AW-410774028/HUewCM_EwdIaEIzU78MB'
				});
			}

			// Misma regla que el login: admin con onboarding abierto entra en
			// /getting-started.
			const target = await resolvePostLoginRedirect("/");
			this.props.history.push(target);
			isLogin();
		}
		else {
			this.setState({
				submitted: true,
				isLoading: false,
				errors: errorFormating(this.props)
			});
		}

	}

	render() {
		const { t } = this.props;
		const { user, accepted } = this.state;
		const label = (<div> <span>{t('register.acceptTermsPre')} </span> <a href='https://plain.ninja/condiciones-de-uso/' target='_blank' rel='noopener noreferrer'>{t('register.termsOfUse')}</a> <span> {t('register.acceptTermsMid')} </span> <a href='https://plain.ninja/politica-privacidad/' rel='noopener noreferrer' target='_blank'>{t('register.privacyPolicy')}</a> </div>)
		const { error_message } = this.props;

		return (
			<div className="register-bg">
				<div className="register-left">
					<Logo className="logo" type="logo" />
					<div className="register-content">
						<div className="register-title">{t("register.title")}</div>
						<div className="register-subtitle">
							{t("register.haveAccount")} <Link to="/login">{t("rememberPassword.signIn")}</Link>
						</div>
						<form onSubmit={this.handleSubmit} className="register-form">
							<FormGroup controlId="name" className="form-group register-form-group">
								<FormLabel>{t("register.name")} <span className="label-required">*</span></FormLabel>
								<FormControl
									autoFocus
									type="text"
									value={user.name}
									placeholder={t("register.namePlaceholder")}
									onChange={this.handleChange}
									isInvalid={this.checkValidField('name')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.name}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="surname" className="form-group register-form-group">
								<FormLabel>{t("register.surname")} <span className="label-required">*</span></FormLabel>
								<FormControl
									type="text"
									value={user.surname}
									placeholder={t("register.surnamePlaceholder")}
									onChange={this.handleChange}
									isInvalid={this.checkValidField('surname')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.surname}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="company" className="form-group register-form-group">
								<FormLabel>{t("register.company")} <span className="label-required">*</span></FormLabel>
								<FormControl
									type="company"
									value={user.company}
									placeholder={t("register.companyPlaceholder")}
									onChange={this.handleChange}
									isInvalid={this.checkValidField('company')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.company}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="code" className="form-group register-form-group">
								<FormLabel>{t("register.companyCode")}</FormLabel>
								<FormControl
									type="text"
									value={user.code}
									placeholder={t("register.companyCodePlaceholder")}
									onChange={this.handleChange}
									isInvalid={this.checkValidField('code')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.code}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="email" className="form-group register-form-group">
								<FormLabel>Email <span className="label-required">*</span></FormLabel>
								<FormControl
									type="email"
									placeholder={t("register.emailPlaceholder")}
									value={user.email}
									onChange={this.handleChange}
									isInvalid={this.checkValidField('email')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.email}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="password" className="form-group register-form-group">
								<FormLabel>{t("login.password")} <span className="label-required">*</span></FormLabel>
								<FormControl
									value={user.password}
									onChange={this.handleChange}
									placeholder={t("login.password")}
									type="password"
									isInvalid={this.checkValidField('password')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.password}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="confirmPassword" className="form-group register-form-group">
								<FormLabel>{t("register.confirmPassword")} <span className="label-required">*</span></FormLabel>
								<FormControl
									value={user.confirmPassword}
									onChange={this.handleChange}
									placeholder={t("register.confirmPassword")}
									type="password"
									isInvalid={this.checkValidField('confirmPassword')}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.confirmPassword}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup controlId="acceptCheck" className="form-group register-form-group">
								<FormCheck
									type="checkbox"
									label={label}
									value={accepted}
									onChange={(e) => {
										this.setState({
											accepted: e.target.checked
										});
									}}
								/>
							</FormGroup>
							{error_message && <div className="alert alert-danger">{error_message}</div>}
							<SubmitButton
								block
								disabled={!this.validateForm()}
								type="submit"
								isLoading={this.state.isLoading}
								text={t("register.submit")}
								loadingText={t("register.submitting")}
							/>
						</form>
					</div>
				</div>
				<div className="register-right"></div>
			</div>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.authReducer;
};

export default connect(mapStateToProps, userActions)(withTranslation()(Register));
// export default Register;